import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

/**
 * setup firebase
 */
const firebaseConfig = {
  apiKey: 'AIzaSyCQd3sTa3FnoXwav8K1sFRXC-WGFnabxrQ',
  authDomain: 'walter-fddbb.firebaseapp.com',
  databaseURL: 'https://walter-fddbb.firebaseio.com',
  projectId: 'walter-fddbb',
  storageBucket: 'walter-fddbb.appspot.com',
  messagingSenderId: '212461561123',
  appId: '1:212461561123:web:76289cbff421c9e3bb1896',
};
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const database = firebase.database();

export {
  auth,
  database,
};
